import type {
	ShadowLocation,
	ShadowSensor,
	ShadowZone,
} from "../../types/location-map";

import { isValidCoordinatePair } from "../shared/coordinates";

export type IndexedMapSensor = ShadowSensor & {
	locationId: string;
	locationName: string;
	zoneBorderWidth?: number;
	zoneBoundary?: ShadowZone["boundary"];
	zoneBoundaryKind?: ShadowZone["boundaryKind"];
	zoneBoundaryMode?: ShadowZone["boundaryMode"];
	zoneColor?: string;
	zoneId: string;
	zoneName: string;
};

/** Flatten location.zones[].sensors[] into geolocated sensors with zone ids. */
export const indexMapSensorsFromTree = (
	locations: ShadowLocation[],
	allowedSensorIds?: null | Set<string>,
): IndexedMapSensor[] => {
	const indexed: IndexedMapSensor[] = [];

	for (const location of locations) {
		for (const zone of location.zones ?? []) {
			for (const sensor of zone.sensors ?? []) {
				if (allowedSensorIds && !allowedSensorIds.has(sensor.id)) continue;
				if (!isValidCoordinatePair(sensor.geolocation?.coordinates)) continue;

				indexed.push({
					...sensor,
					locationId: location.id,
					locationName: location.name,
					zoneBorderWidth: zone.borderWidth,
					zoneBoundary: zone.boundary,
					zoneBoundaryKind: zone.boundaryKind,
					zoneBoundaryMode: zone.boundaryMode,
					zoneColor: zone.color,
					zoneId: zone.id,
					zoneName: zone.name,
				});
			}
		}
	}

	return indexed;
};
